import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loading from '@/components/Loading.vue';
import { chain, startCase } from 'lodash';
import pluralize from 'pluralize';
import SearchBox from '@/components/SearchBox.vue';
const searchResultsModule = namespace('searchResults');
let SearchResultsPage = class SearchResultsPage extends Vue {
    constructor() {
        super(...arguments);
        this.selectedSearchTypes = [];
        this.isSearching = false;
        this.pluralize = pluralize;
        this.startCase = startCase;
    }
    get title() {
        let titleString = 'Search Results' + Vue.prototype.$titleSuffix;
        if (this.searchText) {
            return this.searchText + ' | ' + titleString;
        }
        return titleString;
    }
    created() {
        this.fetchResults();
    }
    fetchData() {
        this.fetchResults();
    }
    fetchResults() {
        if (this.searchText) {
            this.isSearching = true;
            this.fetchSearchResults(this.searchText).then(() => {
                this.isSearching = false;
                this.selectedSearchTypes = chain(this.searchResults)
                    .map('globalSearchTermType')
                    .uniq()
                    .value();
            });
        }
    }
    get searchTypes() {
        return chain(this.searchResults).map(({ globalSearchTermType }) => ({
            value: globalSearchTermType,
            text: startCase(globalSearchTermType)
        })).uniq().value();
    }
    get filteredSearch() {
        return this.searchResults.filter(({ globalSearchTermType }) => this.selectedSearchTypes.includes(globalSearchTermType));
    }
    clearSelection() {
        this.selectedSearchTypes = [];
    }
};
__decorate([
    searchResultsModule.State
], SearchResultsPage.prototype, "searchResults", void 0);
__decorate([
    searchResultsModule.Action
], SearchResultsPage.prototype, "fetchSearchResults", void 0);
__decorate([
    Prop(String)
], SearchResultsPage.prototype, "searchText", void 0);
__decorate([
    Watch('$route')
], SearchResultsPage.prototype, "fetchData", null);
SearchResultsPage = __decorate([
    Component({
        components: {
            SearchBox,
            Loading
        }
    })
], SearchResultsPage);
export default SearchResultsPage;
